<template>
    <div>
        <v-btn rounded="lg" :loading="loading" block class="gradient-color-primary" @click="flushCache">
            Cache flush (ganzer Cache)
        </v-btn>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    methods: {
        ...mapActions('agency', ['flushWholeCache']),
        async flushCache() {
            const cacheFlushed = await this.$store.dispatch('agency/flushWholeCache');
            if (cacheFlushed.data.message) {
                window.alert(cacheFlushed.data.message);
            }
            else {
                window.alert('ERROR: Bitte Console.log prüfen');
            }
        }
    },
    computed: {
        ...mapState('agency', ['loading'])
    }
}
</script>

<style lang="scss" scoped>
/* Your styles here */
</style>